"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const decimal_js_1 = __importDefault(require("decimal.js"));
const jsbi_1 = __importDefault(require("jsbi"));
const react_1 = require("react");
const utils_1 = require("src/misc/utils");
const ExchangeRate_1 = __importDefault(require("../ExchangeRate"));
const TransactionFee_1 = __importDefault(require("./TransactionFee"));
const cn_1 = require("src/misc/cn");
const Index = ({ quoteResponse, fromTokenInfo, toTokenInfo, loading, containerClassName, }) => {
    const rateParams = {
        inAmount: (quoteResponse === null || quoteResponse === void 0 ? void 0 : quoteResponse.quoteResponse.inAmount) || jsbi_1.default.BigInt(0),
        inputDecimal: fromTokenInfo.decimals,
        outAmount: (quoteResponse === null || quoteResponse === void 0 ? void 0 : quoteResponse.quoteResponse.outAmount) || jsbi_1.default.BigInt(0),
        outputDecimal: toTokenInfo.decimals,
    };
    const priceImpact = utils_1.formatNumber.format(new decimal_js_1.default((quoteResponse === null || quoteResponse === void 0 ? void 0 : quoteResponse.quoteResponse.priceImpactPct) || 0).mul(100).toDP(2));
    const priceImpactText = Number(priceImpact) < 0.01 ? undefined : `-${priceImpact}%`;
    const fee = (0, react_1.useMemo)(() => {
        if (!quoteResponse) {
            return 0;
        }
        return quoteResponse.quoteResponse.feeBps / 100;
    }, [quoteResponse]);
    const router = (0, react_1.useMemo)(() => {
        if (!quoteResponse) {
            return;
        }
        return quoteResponse.quoteResponse.router;
    }, [quoteResponse]);
    const gasFee = (0, react_1.useMemo)(() => {
        if (quoteResponse) {
            const { prioritizationFeeLamports } = quoteResponse.quoteResponse;
            if (prioritizationFeeLamports) {
                return prioritizationFeeLamports / 1e9; // Convert lamports to SOL
            }
        }
        return 0;
    }, [quoteResponse]);
    // const hasAtaDeposit = (feeInformation?.ataDeposits.length ?? 0) > 0;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, cn_1.cn)('mt-4 space-y-4 border border-white/5 rounded-xl', containerClassName), children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between text-xs", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-primary-text/50", children: (0, jsx_runtime_1.jsx)("span", { children: "Rate" }) }), jsbi_1.default.greaterThan(rateParams.inAmount, jsbi_1.default.BigInt(0)) &&
                        jsbi_1.default.greaterThan(rateParams.outAmount, jsbi_1.default.BigInt(0)) ? ((0, jsx_runtime_1.jsx)(ExchangeRate_1.default, { loading: loading, rateParams: rateParams, fromTokenInfo: fromTokenInfo, toTokenInfo: toTokenInfo, reversible: true })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-primary-text/50", children: '-' }))] }), priceImpactText && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between text-xs text-primary-text/50", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { children: "Price Impact" }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-primary-text", children: priceImpactText })] })), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between text-xs", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-primary-text/50", children: (0, jsx_runtime_1.jsx)("span", { children: "Fee" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "text-primary-text", children: [fee, "%"] })] }), (0, jsx_runtime_1.jsx)(TransactionFee_1.default, { gasFee: gasFee, gasless: quoteResponse === null || quoteResponse === void 0 ? void 0 : quoteResponse.quoteResponse.gasless })] }));
};
exports.default = Index;
